import React from "react";
import ConfirmPayment from "../Payment/ConfirmPayment";

const PlanConfirm = () => {
  return (
    <React.Fragment>
      <div className="plan_confirm">
        <ConfirmPayment />
      </div>
    </React.Fragment>
  );
};

export default PlanConfirm;
